<div class="reale-theme-style2" fxLayout="column" fxLayoutGap="1rem">
    <div class="exit-modal" fxFlexAlign="end">
        <button mat-icon-button [mat-dialog-close]="true">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <div>
    </div>
    <div *ngIf="data.content" [innerHTML]="data.content | safeHtml"></div>

</div>